import { render, staticRenderFns } from "./linksForm.vue?vue&type=template&id=1d5f8842&scoped=true&"
import script from "./linksForm.vue?vue&type=script&lang=js&"
export * from "./linksForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f8842",
  null
  
)

export default component.exports